import type { DashboardAssetType } from "../../types.js";

export interface AssetUploadCopy {
  readonly title: string;
  readonly helper: string;
  readonly prompt: string;
  readonly accept: string;
}

export const ASSET_UPLOAD_COPY: Record<DashboardAssetType, AssetUploadCopy> = {
  model: {
    title: "Upload 3D Model",
    helper: "GLB only",
    prompt: "Select a GLB file to stage this 3D model.",
    accept: ".glb,model/gltf-binary",
  },
  image: {
    title: "Upload Image",
    helper: "PNG / JPG / JPEG / WEBP",
    prompt: "Choose an image file to stage this asset.",
    accept: ".png,.jpg,.jpeg,.webp,image/png,image/jpeg,image/webp",
  },
  pdf: {
    title: "Upload PDF",
    helper: "PDF only",
    prompt: "Choose a PDF document to stage this asset.",
    accept: ".pdf,application/pdf",
  },
  video: {
    title: "Upload Video",
    helper: "MP4 / WEBM / MOV",
    prompt: "Choose a video file to stage this asset.",
    accept: ".mp4,.webm,.mov,video/mp4,video/webm,video/quicktime",
  },
  cad: {
    title: "Upload CAD File",
    helper: "STEP / IGES / SolidWorks / CATIA / Inventor / Rhino / IFC / 3MF",
    prompt: "Choose a CAD file for automatic conversion to a WebGL-ready 3D model.",
    accept: ".step,.stp,.iges,.igs,.catpart,.catproduct,.cgr,.jt,.asm,.prt,.plmxml,.xpr,.xas,.sldprt,.sldasm,.slddrw,.model,.3dxml,.ipt,.iam,.sat,.vda,.x_t,.x_b,.3dm,.ifc,.amf,.3mf",
  },
};

export function getAssetUploadCopy(assetType: DashboardAssetType): AssetUploadCopy {
  return ASSET_UPLOAD_COPY[assetType];
}

